export default "__VITE_ASSET___DPVh7dT__"